module.exports = __webpack_public_path__ + "img/Icon-tree-team-lifecycle.dafd9fca.svg";